'use client';

export default function AddSectionButton({ onClick }) {
  return (
    <div style={{ marginTop: '2rem' }}>
      <h3>Section Management</h3>
      <p>Create a new section with custom meeting schedule.</p>
      <button 
        onClick={onClick}
        className="addSectionButton"
        style={{
          backgroundColor: '#0070f3',
          color: 'white',
          padding: '0.75rem 1.5rem',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '1rem',
          fontWeight: '500',
          marginTop: '1rem',
          transition: 'background-color 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#0051a2';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = '#0070f3';
        }}
      >
        Add New Section
      </button>
    </div>
  );
}